import { render, staticRenderFns } from "./AppNavigationHeaderNewEvent.vue?vue&type=template&id=1194983e&scoped=true&"
import script from "./AppNavigationHeaderNewEvent.vue?vue&type=script&lang=js&"
export * from "./AppNavigationHeaderNewEvent.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigationHeaderNewEvent.vue?vue&type=style&index=0&id=1194983e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1194983e",
  null
  
)

export default component.exports